import { BenefitsValueObjectsBenefitTransactionCategoryEnum } from 'generated/resources/graphql'

export type BenefitCategory = BenefitsValueObjectsBenefitTransactionCategoryEnum

const SUPPORTED_MARKETS = ['es', 'pt'] as const
export type SupportedMarket = (typeof SUPPORTED_MARKETS)[number]

export const MEALS_LIMIT_EUR_SPAIN = 22000 // 220€
const TRANSPORTATION_LIMIT_EUR_SPAIN = 13636 // 136.36€
const MEALS_LIMIT_EUR_PORTUGAL = 20400 // 204€

export const getMarketLimits = (
  market: SupportedMarket
): Partial<Record<BenefitCategory, number>> => {
  switch (market) {
    case 'es':
      return {
        meals: MEALS_LIMIT_EUR_SPAIN,
        transportation: TRANSPORTATION_LIMIT_EUR_SPAIN,
      }
    case 'pt':
      return {
        meals: MEALS_LIMIT_EUR_PORTUGAL,
      }
    default:
      // Default to Spain limits for safety
      return {
        meals: MEALS_LIMIT_EUR_SPAIN,
        transportation: TRANSPORTATION_LIMIT_EUR_SPAIN,
      }
  }
}

export const getAvailableCategories = (market: SupportedMarket): BenefitCategory[] => {
  const limits = getMarketLimits(market)

  return Object.keys(limits).filter(function isBenefitCategory(key): key is BenefitCategory {
    return key in limits
  })
}
